<template>
  <section
    class="hero"
    :style="{  paddingTop: '130px' }"
  >
    <!-- 主內容 -->
    <div class="hero__inner">
      <div class="container section section--tight">
        <div class="grid grid-2-lg">
          <!-- 左：課程介紹 -->
          <div class="glass" style="padding:24px">
            <div style="display:flex;align-items:center;gap:12px;margin-bottom:10px">
              <img v-if="avatarUrl" :src="avatarUrl" alt="avatar" class="avatar" />
              <div style="display:flex;gap:8px;flex-wrap:wrap">
                <span class="badge badge--green">新版 優越 3.0</span>
                <span class="badge badge--gold">2 個月速成</span>
              </div>
            </div>

            <h1 class="h1" style="margin:0">
              Web3 項目速成課程
              <span style="background:linear-gradient(90deg,var(--brand-gold),var(--brand-accent));-webkit-background-clip:text;background-clip:text;color:transparent">(優越 3.0)</span>
            </h1>

            <p class="lead lead--sm mt-12">
              學習 <strong style="color:var(--brand-gold)">2 個月</strong> 快速開發自己的
              <strong>NFT、DeFi、腳本程式</strong>；從合約、前端到自動化營運，一條龍完成。
            </p>

            <!-- 社會證明 -->
            <div class="social-proof">
              <div class="sp-left">
                <svg v-for="i in 5" :key="i" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="16" height="16" style="fill:var(--brand-gold)">
                  <path d="M10 15l-5.878 3.09L5.64 11.545 1 7.91l6.061-.882L10 1l2.939 6.028L19 7.91l-4.64 3.636 1.518 6.545z"/>
                </svg>
                <span>4.9/5.0（1,200+ 評價）</span>
              </div>
              <span class="sep">|</span>
              <span>超過 3,000 名學員實戰</span>
            </div>

            <!-- 三個亮點 -->
            <ul class="bullets">
              <li><span class="dot" style="background:#6ee7b7"></span>完整 DApp 實作</li>
              <li><span class="dot" style="background:#7dd3fc"></span>適用於大部分公鏈</li>
              <li><span class="dot" style="background:#f0abfc"></span>鏈上交易自動化</li>
            </ul>

            <!-- CTA -->
           <div class="cta-row">
  <button class="btn-cta" @click="open = true">
    <span class="btn-glow"></span>
    <span class="btn-text">🔥 免費公開課</span>
    <span class="btn-arrow">⬅</span>
  </button>
</div>

            <p class="lead lead--xs mt-16">
              報名即可獲得：《Web3 項目開發—學習藍圖》與《Web3 加密服務》電子版。
              從環境搭建、智能合約、前端+練端串接。
            </p>
          </div>

          <!-- 右：影片 -->
<div
  class="card video-card"
  @click="open = true"
  @keydown.enter.prevent="open = true"
  @keydown.space.prevent="open = true"
  tabindex="0"
  role="button"
  aria-label="開啟免費公開課報名"
>
  <div class="aspect-video video-wrapper">
    <img :src="videoCover" alt="課程導覽影片封面" class="video-cover" />
    <div class="video-overlay"><div class="play-icon">▶</div></div>
  </div>
  <div class="video-meta">
    <h3>課程導覽（節錄）</h3>
    <p>先看免費內容再決定是否加入完整課程。</p>
  </div>
</div>


        </div>
      </div>
    </div>

    <!-- 評論區 -->
    <div class="container tsec tsec--tight">
      <div class="tgrid tgrid-2-lg">
        <div class="tcard tcard--compact">
          <div class="tstars">
            <svg v-for="i in 5" :key="'l'+i" viewBox="0 0 20 20"><path d="M10 15l-5.878 3.09L5.64 11.545 1 7.91l6.061-.882L10 1l2.939 6.028L19 7.91l-4.64 3.636 1.518 6.545z"/></svg>
          </div>
          <p class="tquote tquote--sm">
            我是一個完全不懂 0 基礎的小白，跟著課程一步一步學，從完全不懂到能做出自己的智能合約，
            並且可以跟頁面進行交互。學習過程中，有非常多低級的問題，G大也會耐心回答我，真的非常非常感謝院長。
          </p>
          <div class="tauthor">— 學員回饋</div>
        </div>

        <div class="tcard tcard--compact">
          <div class="tstars">
            <svg v-for="i in 5" :key="'r'+i" viewBox="0 0 20 20"><path d="M10 15l-5.878 3.09L5.64 11.545 1 7.91l6.061-.882L10 1l2.939 6.028L19 7.91l-4.64 3.636 1.518 6.545z"/></svg>
          </div>
          <p class="tquote tquote--sm">
            前段時間去面試，老闆問我有沒有做過相關項目，我就把課程的實戰項目拿出來。
            因為項目是我自己做的，所以面試過程的一些問題，我基本都能回答上；下午我就收到了錄取通知，非常感謝院長。
          </p>
          <div class="tauthor">— 署名</div>
        </div>
      </div>
    </div>

    <!-- 報名模態框 -->
    <EnrollModal :open="open" @close="open = false" @success="onSuccess" />
  </section>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import EnrollModal from '../components/EnrollModal.vue'

const router = useRouter()
const open = ref(false)

// const bgUrl = '/images/hero-bg.jpg'
const avatarUrl = '/images/avatar.png'
// const youtube = 'https://youtu.be/nJtinqWl6h4'
const videoCover = '/images/course-preview.jpg'

function onSuccess() {
  open.value = false
  router.push({ name: 'PublicCourse' })
}
</script>

<style scoped>
/* ===== 頁面結構 ===== */
.hero {
  --middle-gap: clamp(24px, 5vw, 64px); /* 👈 控制課程與評論的間距 */
  min-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  background-position: center;
  background-size: cover;
}

.hero__inner {
  /* flex: 1;  */
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

/* ===== 主內容置中 ===== */
.section,
.section--tight {
  margin: 0 auto !important;
  padding: 20px 0 8px !important;
  max-width: 1250px; /* 控制總寬度，整塊往中間靠 */
}

/* ===== 課程內容兩欄布局 ===== */
.grid {
  display: grid;
  align-items: start;
  justify-content: center; /* ✅ 水平置中關鍵 */
  gap: 24px;
  grid-template-columns: repeat(auto-fit, minmax(480px, 1fr));
  width: 100%;
  max-width: 1120px; /* ✅ 控制內層寬度 */
  margin: 0 auto;
}
.glass,
.video-card {
  width: 100%;
}

/* ===== 視覺微調 ===== */
.mt-12 { margin-top: 12px; }
.mt-16 { margin-top: 16px; }

.lead--sm {
  max-width: 640px;
  font-size: 15px;
  opacity: .9;
}
.lead--xs {
  max-width: 720px;
  font-size: 14px;
  opacity: .9;
}

/* ===== 社會證明 ===== */
.social-proof {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  font-size: 13px;
  opacity: .9;
}
.sp-left {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

/* ===== 亮點列表 ===== */
.bullets {
  margin-top: 14px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  font-size: 13px;
}
.bullets li {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}
.dot {
  margin-top: 6px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
}

/* ===== 影片卡 ===== */
.video-card {
  padding: 14px;
  display: flex;
  flex-direction: column;
}
.video-meta {
  padding: 10px 6px;
}
.video-meta h3 {
  margin: 0 0 2px 0;
  font-weight: 700;
  color: var(--text);
  font-size: 16px;
}
.video-meta p {
  margin: 0;
  color: var(--muted);
  font-size: 13px;
}

/* ===== CTA 列 ===== */
.cta-row {
  margin-top: 16px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

/* ===== 評論卡 ===== */
.tsec {
  padding: 8px 0 6px;
  margin-top: var(--middle-gap) !important;
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;
}
.tgrid {
  display: grid;
  gap: 18px;
}
@media (min-width: 1024px) {
  .tgrid-2-lg {
    grid-template-columns: 1fr 1fr;
  }
}

/* ✅ 去掉玻璃化，改為純深色卡片 */
.tcard {
  color: #fff;
  background: transparent;  
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 14px 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
}
.tstars {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 8px;
}
.tstars svg {
  width: 18px;
  height: 18px;
  fill: var(--brand-gold);
}

.tquote {
  line-height: 1.65;
  color: rgba(255, 255, 255, 0.92);
}
.tquote--sm {
  font-size: clamp(12.5px, 1.4vw, 14.5px);
}
.tauthor {
  margin-top: 8px;
  opacity: 0.85;
  font-weight: 600;
  font-size: 12px;
}

/* ===== 影片遮罩層（防止直接播放） ===== */
/* 可選：封面圖版本 */
.video-wrapper{position:relative;overflow:hidden;border-radius:12px;cursor:pointer}
.video-wrapper:hover .video-cover{transform:scale(1.03)}
.video-overlay{position:absolute;inset:0;display:grid;place-items:center;;transition:background .3s ease}
.video-wrapper:hover .video-overlay{background:rgba(0,0,0,.45)}
.play-icon{font-size:46px;color:rgba(255,255,255,.9);text-shadow:0 4px 12px rgba(0,0,0,.3);transition:transform .2s ease,opacity .2s ease}
.video-wrapper:hover .play-icon{transform:scale(1.1)}
/* ===== 美化版 CTA 按鈕 ===== */
.btn-cta {
  position: relative;
  display: inline-flex;
  align-items: center;
  /* justify-content: center; */
  gap: 8px;
  width: 50%;
  padding: 14px 18px;
  font-size: 20px;
  font-weight: 700;
  color: #111;
  background: linear-gradient(90deg, #f7ce46, #f08f2e);
  border: none;
  border-radius: 14px;
  box-shadow: 0 6px 18px rgba(247, 206, 70, 0.3);
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.15s ease, box-shadow 0.2s ease;
}

.btn-cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(247, 206, 70, 0.45);
}

.btn-cta:active {
  transform: scale(0.98);
}

/* 光澤動畫層 */
.btn-cta .btn-glow {
  position: absolute;
  top: 0;
  left: -60%;
  width: 50%;
  height: 100%;
  background: linear-gradient(120deg, rgba(255,255,255,0.4), rgba(255,255,255,0));
  transform: skewX(-25deg);
  animation: btn-shine 2.8s infinite;
}

@keyframes btn-shine {
  0% { left: -60%; }
  60% { left: 110%; }
  100% { left: 110%; }
}

/* 文字部分 */
.btn-cta .btn-text {
  position: relative;
  z-index: 2;
}

.btn-cta .btn-arrow {
  position: relative;
  z-index: 2;
  font-size: 22px;
  transition: transform 0.2s ease;
}

.btn-cta:hover .btn-arrow {
  transform: translateX(-3px);
}

</style>
